import BatteryIcon from '@mui/icons-material/BatteryChargingFull';
import PlantIcon from '@mui/icons-material/Power';
import SolarIcon from '@mui/icons-material/SolarPower';
import PvsIcon from '../../icons/pvs.svg?react';

interface Props {
  type: string | null | undefined;
}

function PlantTypeIcon({ type }: Readonly<Props>) {
  const normalized = type?.toUpperCase() ?? '';

  if (normalized.includes('PV') && normalized.includes('S')) {
    return <PvsIcon height={16} />;
  }
  if (normalized.includes('PV')) {
    return <SolarIcon fontSize="small" />;
  }
  if (normalized.includes('S') || normalized.includes('ESS') || normalized.includes('BESS')) {
    return <BatteryIcon fontSize="small" />;
  }

  return <PlantIcon fontSize="small" />;
}

export default PlantTypeIcon;
